<template>
  <div style="height: 100%;background-color: #f2f2f2;overflow-y: auto">
    <div style="height: 150px;margin: 0 20px">
      <div class="top-card">
        <el-row style="width: 100%;height: 100%">
          <el-col :span="12" style="height: 100%">
            <div class="top-card-value"><span style="font-size: 30px;margin-right: 5px">{{curCntAll}}</span>张</div>
            <div class="top-card-key">床位数</div>
          </el-col>
          <el-col :span="12" style="height: 100%">
            <img src="../../assets/oldPersonHome/bed_all.png">
          </el-col>
        </el-row>
      </div>
      <div class="top-card">
        <el-row style="width: 100%;height: 100%">
          <el-col :span="12" style="height: 100%">
            <div class="top-card-value"><span style="font-size: 30px;margin-right: 5px">{{curCntUsed}}</span>张</div>
            <div class="top-card-key">已入住</div>
          </el-col>
          <el-col :span="12">
            <img src="../../assets/oldPersonHome/bed_used.png">
          </el-col>
        </el-row>
      </div>
      <div class="top-card">
        <el-row style="width: 100%;height: 100%">
          <el-col :span="12" style="height: 100%">
            <div class="top-card-value"><span style="font-size: 30px;margin-right: 5px">{{curCntWait}}</span>张</div>
            <div class="top-card-key">已预约</div>
          </el-col>
          <el-col :span="12" style="height: 100%">
            <img src="../../assets/oldPersonHome/bed_wait.png">
          </el-col>
        </el-row>
      </div>
      <div class="top-card">
        <el-row style="width: 100%;height: 100%">
          <el-col :span="12" style="height: 100%">
            <div class="top-card-value"><span style="font-size: 30px;margin-right: 5px">{{curCntFree}}</span>张</div>
            <div class="top-card-key">空闲</div>
          </el-col>
          <el-col :span="12" style="height: 100%">
            <img src="../../assets/oldPersonHome/bed_free.png">
          </el-col>
        </el-row>
      </div>
    </div>

    <div style="height: 10px"></div>
    <div style="height: 50px;margin: 0 20px">
      历史入住情况：
      <el-date-picker v-fixZoom :clearable="false" v-model="sendDate" type="daterange" unlink-panels
                      range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
                      value-format="yyyy-MM-dd" style="margin-right: 10px; width: 400px">
      </el-date-picker>
      <el-button type="success" @click="getSearchData">查询</el-button>
    </div>
    <div style="height: 20px"></div>
    <div :style="{height: '360px', margin: '0 20px', zoom: 1 / this.golobleObject.zoom}" ref="line1"></div>
<!--    <div style="height: 20px"></div>-->
<!--    <div style="height: 380px;margin: 0 20px" ref="pie"></div>-->
<!--    <div style="height: 20px"></div>-->
<!--    <div style="height: 360px;margin: 0 20px" ref="line2"></div>-->
  </div>
</template>

<script>
import {accomodationgethomebedstat} from '../../api/yanglaoyuan/homebed'

export default {
  name: 'accommodationStatistics',
  data () {
    return {
      chartLine1: null,
      chartPie: null,
      chartLine2: null,

      pickerOptions: {
        shortcuts: []
      },
      entityId: [],
      sendDate: [],

      curCntAll: 0,
      curCntUsed: 0,
      curCntWait: 0,
      curCntFree: 0,

      hisDataX: [],
      hisDataUsed: [],
      hisDataWait: [],
      hisDataFree: []
    }
  },
  created () {
    let loginResp = this.$store.state.user.LoginResp
    this.entityId.push(loginResp.entity_id)
    this.getTimeObj()
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    let end = new Date().format('yyyy-MM-dd')
    const start = this.commonType.GetDateStr(-30)
    this.sendDate = [start.format('yyyy-MM-dd'), end]
    this.getStartData()
  },
  mounted () {
    window.addEventListener('resize', this.chartResize)
    // window.addEventListener('resize', this.chartPie)
    // window.addEventListener('resize', this.chartLine2)

    // this.getChartPie()
    // this.getChartLineData2()
  },
  beforeDestroy () {
    if (!this.chartLine1) {
      return
    }
    window.removeEventListener('resize', this.chartResize)
    this.chartLine1.dispose()
    this.chartLine1 = null
  },
  methods: {
    // 时间
    mGetDate (year, month) {
      const d = new Date(year, month, 0)
      return d.getDate()
    },
    getTimeObj () {
      const dataArr = []
      const data = new Date()
      data.setMonth(data.getMonth() + 1, 1)// 获取到当前月份,设置月份
      for (let i = 0; i < 12; i++) {
        data.setMonth(data.getMonth() - 1) // 每次循环一次 月份值减1
        let m = data.getMonth() + 1
        m = m < 10 ? '0' + m : m
        dataArr.push(data.getFullYear() + '-' + (m))
      }
      const endDate = []
      for (let i = 1; i < dataArr.length; i++) {
        const arr = dataArr[i].split('-')
        const obj = {}
        let endDay = ''
        if (arr[1][0] === '0') {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1][1]))
          obj.text = arr[0] + '年' + arr[1][1] + '月'
        } else {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1]))
          obj.text = arr[0] + '年' + arr[1] + '月'
        }
        obj.start = arr[0] + '-' + arr[1] + '-' + '01'
        obj.end = arr[0] + '-' + arr[1] + '-' + endDay
        endDate.push(obj)
      }
      const arrTime = [
        {
          text: '本月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setDate(1)
            picker.$emit('pick', [start, end])
          }
        }
      ]
      for (let i = 0; i < endDate.length; i++) {
        const item = {
          text: endDate[i].text,
          onClick (picker) {
            picker.$emit('pick', [endDate[i].start, endDate[i].end])
          }
        }
        arrTime.push(item)
      }
      this.pickerOptions.shortcuts = arrTime
    },
    chartResize () {
      this.chartLine1.resize()
    },

    getChartLineData1 () {
      if (!this.chartLine1) {
        this.chartLine1 = this.$echarts.init(this.$refs.line1)
      }

      this.chartLine1.setOption({
        title: {},
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['已入住', '空闲', '已预约']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.hisDataX
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '已入住',
            type: 'line',
            // stack: 'Total',
            smooth: true,
            data: this.hisDataUsed
          },
          {
            name: '空闲',
            type: 'line',
            // stack: 'Total',
            smooth: true,
            data: this.hisDataFree
          },
          {
            name: '已预约',
            type: 'line',
            // stack: 'Total',
            smooth: true,
            data: this.hisDataWait
          }
        ]
      })
    },
    getChartPie () {
      this.chartPie = this.$echarts.init(this.$refs.pie)
      this.chartPie.setOption({
        title: {
          text: '二、当前床位情况'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          // bottom: 10,
          left: 'center'
        },
        series: [
          {
            name: '床位数量',
            type: 'pie',
            radius: '50%',
            data: [
              { value: 580, name: '已入住' },
              { value: 735, name: '空闲' },
              { value: 484, name: '已预约' },
              { value: 300, name: '已试住' }
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      })
    },
    getChartLineData2 () {
      this.chartLine2 = this.$echarts.init(this.$refs.line2)
      this.chartLine2.setOption({
        title: {text: '三、近半年消费信息走线图'},
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['未缴费', '已缴费']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['1月', '2月', '3月', '4月', '5月', '6月']
        },
        yAxis: {
          type: 'value'
        },
        color: ['#cc003a', '#197519'],
        series: [
          {
            name: '未缴费',
            type: 'line',
            // stack: 'Total',
            smooth: true,
            data: [120, 132, 101, 134, 90, 230]
          },
          {
            name: '已缴费',
            type: 'line',
            // stack: 'Total',
            smooth: true,
            data: [220, 182, 191, 234, 290, 330]
          }
        ]
      })
    },

    getStartData () {
      this.getHomeBedStatCurData()
      this.getHomeBedStatHisData()
    },
    getSearchData () {
      this.getHomeBedStatHisData()
    },

    // 访问接口
    getHomeBedStatCurData () {
      let now = new Date().format('yyyy-MM-dd')
      let params = {
        page: 1,
        size: 9999
      }
      let data = {
        eid: this.entityId,
        time_flag: 1,
        start_time: now + ' 00:00:00',
        end_time: now + ' 23:59:59'
      }
      accomodationgethomebedstat(params, data).then(res => {
        let data = res.data.arrdata[0]
        this.curCntAll = data.cnt_all
        this.curCntUsed = data.cnt_used
        this.curCntWait = data.cnt_wait
        this.curCntFree = this.curCntAll - this.curCntUsed
      })
    },
    getHomeBedStatHisData () {
      let that = this
      this.hisDataX = []
      this.hisDataUsed = []
      this.hisDataWait = []
      this.hisDataFree = []
      let params = {
        page: 1,
        size: 9999
      }
      let data = {
        eid: this.entityId,
        time_flag: 1,
        start_time: this.sendDate[0] + ' 00:00:00',
        end_time: this.sendDate[1] + ' 23:59:59'
      }
      accomodationgethomebedstat(params, data).then(res => {
        let arr = res.data.arrdata
        arr.forEach(item => {
          let free = item.cnt_all - item.cnt_used
          that.hisDataX.push(item.dt)
          that.hisDataUsed.push(item.cnt_used)
          that.hisDataWait.push(item.cnt_wait)
          that.hisDataFree.push(free)
        })
        that.getChartLineData1()
      })
    }
  }
}
</script>

<style scoped>
.top-card {
  float: left;
  width: 200px;
  height: calc(100% - 70px);
  margin: 20px 10px;
  padding: 15px;
  background-color: #fbfbfb;
  text-align: center;
}
.top-card-value {
  width: 100%;
  height: 50px;
  line-height: 50px;
  color: #00aaff;
}
.top-card-key {
  width: 100%;
  height: calc(100% - 50px);
  color: gray;
  /*line-height: calc(100% - 70px);*/
}
</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/accommodationStatistics.vue